module.exports = __webpack_public_path__ + "static/img/video-10.f5224a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/video-10.jpg
// module id = x0Kj
// module chunks = 12